/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CompanySettingsQuery = gql`
  query getCompanySettings {
    companySettings {
      name,
      settings
    }
  }
`;

export const AppSettingsQuery = gql`
  query getAppSettings($appKey: String!) {
    getAppSettings(key: $appKey) {
      name,
      settings
    }
  }
`;
